// Function to remove CSS rules containing specific styles
function removeCSSProperties(selectorText, properties) {
  Array.from(document.styleSheets).forEach((stylesheet) => {
    try {
      Array.from(stylesheet.cssRules).forEach((rule, index) => {
        if (rule.selectorText === selectorText) {
          // Check if the rule contains the styles
          properties.forEach((property) => {
            if (rule.style.getPropertyValue(property)) {
              rule.style.removeProperty(property); // Remove the property
            }
          });

          // If no styles remain, delete the rule entirely
          if (!rule.style.cssText.trim()) {
            stylesheet.deleteRule(index);
          }
        }
      });
    } catch (e) {
      console.warn("Cannot modify stylesheet:", e);
    }
  });

}

// Set the function to run on window load
window.onload = function () {
  setTimeout(function () {
    removeCSSProperties(
      // .bold_option_value:hover
      ".bold_option_swatch_title, .bold_tooltip:hover > :first-child",
      ["height", "line-height", "padding"]
    );
  }, 800);
};
